import { gql } from '@apollo/client';
const GET_MODEL_SPECIFICATION_VARIANT_COST_DETAILS = gql `
  query GetModelSpecificationVariantCostDetails($modelSpecificationVariantId: ID!) {
    node(id: $modelSpecificationVariantId) {
      ... on ModelSpecificationVariantNode {
        id
        quantity
        estimatedCost
        color {
          id
          name
        }
        size {
          id
          sizeName {
            id
            name
          }
        }
        componentVariantCostSummaries {
          id
          component {
            id
            name
            productCategory {
              id
              precision
            }
            productSnapshot {
              id
              product {
                id
              }
            }
          }
          color
          size
          consumptionValue
          consumptionType {
            id
            name
            labelPL
            labelEN
            integerValues
          }
          price {
            value
            currencyIsoCode
          }
          costInComponentVariantCurrency {
            value
            currencyIsoCode
          }
          exchangeRate
          costInSpecificationCurrency
        }
        additionalCostSummaries {
          id
          name
          cost {
            value
            currencyIsoCode
          }
          exchangeRate
          costInSpecificationCurrency
        }
      }
    }
  }
`;
export default GET_MODEL_SPECIFICATION_VARIANT_COST_DETAILS;
